<template>

  <v-container fluid class="pt-2 order-invoice-viewer">

    <!-- Title -->
    <v-row class="pa-0 ma-0 mb-4">
      <v-col cols="12" class="d-flex align-center">
        <!-- <v-icon color="white" class="mr-1">mdi-map-marker-outline</v-icon> -->
        <span class="title">{{ title }}</span>
      </v-col>
    </v-row>

    <!-- Invoice Viewer -->
    <v-row class="pa-0 ma-0 d-flex align-center justify-center">
      <v-col cols="12" xs="12" sm="12" md="11" lg="10" class="pt-0 d-flex align-center justify-center">
        <v-progress-circular indeterminate :size="40" style="margin-top:10px" color="primary" v-if="isInvoiceLoading" />
        <div class="invoice-doc-container" v-else-if="loadedInvoiceUrl">
          <embed
              style="border:2px solid #525252;"
              type="application/pdf"
              :src="loadedInvoiceUrl"
              :class="embedClass" />
        </div>
        <div v-else>
          <v-btn color="gray" @click="loadOrderInvoice">
            View Invoice
          </v-btn>
        </div>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>

export default {
  name: 'OrderInvoiceViewer',

  data () {
    return {
      isInvoiceLoading: false,
      loadedInvoiceUrl: null
    }
  },

  props: {
    order: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: 'Order Invoice'
    }
  },

  computed: {
    embedClass () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'embed-xs'
        case 'sm': return 'embed-sm'
        case 'md': return 'embed-md'
        default: return 'embed-lg'
      }
    }
  },

  methods: {
    async loadOrderInvoice () {
      this.isInvoiceLoading = true
      const url = await this.$root.fetchOrderAsset(this.order.id, 'invoice.pdf', true)
      if (url) this.loadedInvoiceUrl = `${url}&response-content-disposition=inline`
      this.isInvoiceLoading = false
    }
  }
}
</script>

<style scoped>
  .order-invoice-viewer .invoice-doc-container {
    text-align: center;
  }

  .embed-xs {
    height: 250px;
    width: 300px;
    /* width: 100%; */
    /* max-width: 360px; */
  }

  .embed-sm {
    height: 300px;
    width: 400px;
    /* width: 100%; */
    /* max-width: 600px; */
  }

  .embed-md {
    height: 500px;
    width: 800px;
    /* width: 100%; */
    /* max-width: 840px; */
  }

  .embed-lg {
    height: 600px;
    width: 840px;
  }
</style>
